module.exports = __webpack_public_path__ + "static/media/slide05.ae2f2442.jpg";